import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN = '[IncidentsModul] GetIncidentVorlagenMitAbteilungen laden';
export const GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_AUSFUEHREN = '[IncidentsModul] GetIncidentVorlagenMitAbteilungen ausführen';
export const GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_ERFOLGREICH = '[IncidentsModul] GetIncidentVorlagenMitAbteilungen laden erfolgreich';
export const GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_FEHLER = '[IncidentsModul] GetIncidentVorlagenMitAbteilungen Ladefehler';
export const GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_NICHT_AUSGEFUEHRT = '[IncidentsModul] GetIncidentVorlagenMitAbteilungen nicht ausgeführt (evtl. Offline)';


export class GetIncidentVorlagenMitAbteilungenAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN;
        constructor(public optPayload: any = null) {}
    }
export class GetIncidentVorlagenMitAbteilungenAusfuehrenAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetIncidentVorlagenMitAbteilungenErfolgreichAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_ERFOLGREICH;
        constructor(public payload: api.IncidentVorlagenMitAbteilungen, public optPayload: any = null) {}
    }
export class GetIncidentVorlagenMitAbteilungenFehlerAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetIncidentVorlagenMitAbteilungenNichtAusgefuehrtAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsQueryIncidentVorlagenMitAbteilungenActions =
    GetIncidentVorlagenMitAbteilungenAction
    | GetIncidentVorlagenMitAbteilungenAusfuehrenAction
    | GetIncidentVorlagenMitAbteilungenErfolgreichAction
    | GetIncidentVorlagenMitAbteilungenFehlerAction
    | GetIncidentVorlagenMitAbteilungenNichtAusgefuehrtAction
    ;
